import { useContext as H, createContext as Y } from "react";
import { jsx as X } from "react/jsx-runtime";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var o = function() {
  return o = Object.assign || function(t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      e = arguments[n];
      for (var s in e)
        Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    }
    return t;
  }, o.apply(this, arguments);
};
function J(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e)
    return e.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function z(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e)
    return r;
  var n = e.call(r), i, s = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      s.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return s;
}
function p() {
  for (var r = [], t = 0; t < arguments.length; t++)
    r = r.concat(z(arguments[t]));
  return r;
}
function Q() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function O() {
  return !Q() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function Z(r, t) {
  return r.require(t);
}
var tt = {};
function l() {
  return O() ? global : typeof window < "u" ? window : typeof self < "u" ? self : tt;
}
function P(r, t, e) {
  var n = e || l(), i = n.__SENTRY__ = n.__SENTRY__ || {}, s = i[r] || (i[r] = t());
  return s;
}
var et = Object.prototype.toString;
function rt(r, t) {
  return et.call(r) === "[object " + t + "]";
}
function G(r) {
  return rt(r, "Object");
}
function q(r) {
  return Boolean(r && r.then && typeof r.then == "function");
}
var F = typeof __SENTRY_DEBUG__ > "u" ? !0 : __SENTRY_DEBUG__, nt = l(), it = "Sentry Logger ", x = ["debug", "info", "warn", "error", "log", "assert"];
function K(r) {
  var t = l();
  if (!("console" in t))
    return r();
  var e = t.console, n = {};
  x.forEach(function(i) {
    var s = e[i] && e[i].__sentry_original__;
    i in t.console && s && (n[i] = e[i], e[i] = s);
  });
  try {
    return r();
  } finally {
    Object.keys(n).forEach(function(i) {
      e[i] = n[i];
    });
  }
}
function B() {
  var r = !1, t = {
    enable: function() {
      r = !0;
    },
    disable: function() {
      r = !1;
    }
  };
  return F ? x.forEach(function(e) {
    t[e] = function() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      r && K(function() {
        var s;
        (s = nt.console)[e].apply(s, p([it + "[" + e + "]:"], n));
      });
    };
  }) : x.forEach(function(e) {
    t[e] = function() {
    };
  }), t;
}
var m;
F ? m = P("logger", B) : m = B();
function w(r) {
  var t, e;
  if (G(r)) {
    var n = {};
    try {
      for (var i = J(Object.keys(r)), s = i.next(); !s.done; s = i.next()) {
        var a = s.value;
        typeof r[a] < "u" && (n[a] = w(r[a]));
      }
    } catch (u) {
      t = { error: u };
    } finally {
      try {
        s && !s.done && (e = i.return) && e.call(i);
      } finally {
        if (t)
          throw t.error;
      }
    }
    return n;
  }
  return Array.isArray(r) ? r.map(w) : r;
}
function S() {
  var r = l(), t = r.crypto || r.msCrypto;
  if (t !== void 0 && t.getRandomValues) {
    var e = new Uint16Array(8);
    t.getRandomValues(e), e[3] = e[3] & 4095 | 16384, e[4] = e[4] & 16383 | 32768;
    var n = function(i) {
      for (var s = i.toString(16); s.length < 4; )
        s = "0" + s;
      return s;
    };
    return n(e[0]) + n(e[1]) + n(e[2]) + n(e[3]) + n(e[4]) + n(e[5]) + n(e[6]) + n(e[7]);
  }
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(i) {
    var s = Math.random() * 16 | 0, a = i === "x" ? s : s & 3 | 8;
    return a.toString(16);
  });
}
var st = function() {
  function r(t) {
    var e = this;
    this._state = 0, this._handlers = [], this._resolve = function(n) {
      e._setResult(1, n);
    }, this._reject = function(n) {
      e._setResult(2, n);
    }, this._setResult = function(n, i) {
      if (e._state === 0) {
        if (q(i)) {
          i.then(e._resolve, e._reject);
          return;
        }
        e._state = n, e._value = i, e._executeHandlers();
      }
    }, this._executeHandlers = function() {
      if (e._state !== 0) {
        var n = e._handlers.slice();
        e._handlers = [], n.forEach(function(i) {
          i[0] || (e._state === 1 && i[1](e._value), e._state === 2 && i[2](e._value), i[0] = !0);
        });
      }
    };
    try {
      t(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  return r.prototype.then = function(t, e) {
    var n = this;
    return new r(function(i, s) {
      n._handlers.push([
        !1,
        function(a) {
          if (!t)
            i(a);
          else
            try {
              i(t(a));
            } catch (u) {
              s(u);
            }
        },
        function(a) {
          if (!e)
            s(a);
          else
            try {
              i(e(a));
            } catch (u) {
              s(u);
            }
        }
      ]), n._executeHandlers();
    });
  }, r.prototype.catch = function(t) {
    return this.then(function(e) {
      return e;
    }, t);
  }, r.prototype.finally = function(t) {
    var e = this;
    return new r(function(n, i) {
      var s, a;
      return e.then(function(u) {
        a = !1, s = u, t && t();
      }, function(u) {
        a = !0, s = u, t && t();
      }).then(function() {
        if (a) {
          i(s);
          return;
        }
        n(s);
      });
    });
  }, r;
}(), k = {
  nowSeconds: function() {
    return Date.now() / 1e3;
  }
};
function ot() {
  var r = l().performance;
  if (!(!r || !r.now)) {
    var t = Date.now() - r.now();
    return {
      now: function() {
        return r.now();
      },
      timeOrigin: t
    };
  }
}
function at() {
  try {
    var r = Z(module, "perf_hooks");
    return r.performance;
  } catch {
    return;
  }
}
var E = O() ? at() : ot(), D = E === void 0 ? k : {
  nowSeconds: function() {
    return (E.timeOrigin + E.now()) / 1e3;
  }
}, V = k.nowSeconds.bind(k), U = D.nowSeconds.bind(D);
(function() {
  var r = l().performance;
  if (!(!r || !r.now)) {
    var t = 3600 * 1e3, e = r.now(), n = Date.now(), i = r.timeOrigin ? Math.abs(r.timeOrigin + e - n) : t, s = i < t, a = r.timing && r.timing.navigationStart, u = typeof a == "number", f = u ? Math.abs(a + e - n) : t, c = f < t;
    return s || c ? i <= f ? r.timeOrigin : a : n;
  }
})();
var M = 100, T = function() {
  function r() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {};
  }
  return r.clone = function(t) {
    var e = new r();
    return t && (e._breadcrumbs = p(t._breadcrumbs), e._tags = o({}, t._tags), e._extra = o({}, t._extra), e._contexts = o({}, t._contexts), e._user = t._user, e._level = t._level, e._span = t._span, e._session = t._session, e._transactionName = t._transactionName, e._fingerprint = t._fingerprint, e._eventProcessors = p(t._eventProcessors), e._requestSession = t._requestSession), e;
  }, r.prototype.addScopeListener = function(t) {
    this._scopeListeners.push(t);
  }, r.prototype.addEventProcessor = function(t) {
    return this._eventProcessors.push(t), this;
  }, r.prototype.setUser = function(t) {
    return this._user = t || {}, this._session && this._session.update({ user: t }), this._notifyScopeListeners(), this;
  }, r.prototype.getUser = function() {
    return this._user;
  }, r.prototype.getRequestSession = function() {
    return this._requestSession;
  }, r.prototype.setRequestSession = function(t) {
    return this._requestSession = t, this;
  }, r.prototype.setTags = function(t) {
    return this._tags = o(o({}, this._tags), t), this._notifyScopeListeners(), this;
  }, r.prototype.setTag = function(t, e) {
    var n;
    return this._tags = o(o({}, this._tags), (n = {}, n[t] = e, n)), this._notifyScopeListeners(), this;
  }, r.prototype.setExtras = function(t) {
    return this._extra = o(o({}, this._extra), t), this._notifyScopeListeners(), this;
  }, r.prototype.setExtra = function(t, e) {
    var n;
    return this._extra = o(o({}, this._extra), (n = {}, n[t] = e, n)), this._notifyScopeListeners(), this;
  }, r.prototype.setFingerprint = function(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }, r.prototype.setLevel = function(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }, r.prototype.setTransactionName = function(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }, r.prototype.setTransaction = function(t) {
    return this.setTransactionName(t);
  }, r.prototype.setContext = function(t, e) {
    var n;
    return e === null ? delete this._contexts[t] : this._contexts = o(o({}, this._contexts), (n = {}, n[t] = e, n)), this._notifyScopeListeners(), this;
  }, r.prototype.setSpan = function(t) {
    return this._span = t, this._notifyScopeListeners(), this;
  }, r.prototype.getSpan = function() {
    return this._span;
  }, r.prototype.getTransaction = function() {
    var t = this.getSpan();
    return t && t.transaction;
  }, r.prototype.setSession = function(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }, r.prototype.getSession = function() {
    return this._session;
  }, r.prototype.update = function(t) {
    if (!t)
      return this;
    if (typeof t == "function") {
      var e = t(this);
      return e instanceof r ? e : this;
    }
    return t instanceof r ? (this._tags = o(o({}, this._tags), t._tags), this._extra = o(o({}, this._extra), t._extra), this._contexts = o(o({}, this._contexts), t._contexts), t._user && Object.keys(t._user).length && (this._user = t._user), t._level && (this._level = t._level), t._fingerprint && (this._fingerprint = t._fingerprint), t._requestSession && (this._requestSession = t._requestSession)) : G(t) && (t = t, this._tags = o(o({}, this._tags), t.tags), this._extra = o(o({}, this._extra), t.extra), this._contexts = o(o({}, this._contexts), t.contexts), t.user && (this._user = t.user), t.level && (this._level = t.level), t.fingerprint && (this._fingerprint = t.fingerprint), t.requestSession && (this._requestSession = t.requestSession)), this;
  }, r.prototype.clear = function() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this;
  }, r.prototype.addBreadcrumb = function(t, e) {
    var n = typeof e == "number" ? Math.min(e, M) : M;
    if (n <= 0)
      return this;
    var i = o({ timestamp: V() }, t);
    return this._breadcrumbs = p(this._breadcrumbs, [i]).slice(-n), this._notifyScopeListeners(), this;
  }, r.prototype.clearBreadcrumbs = function() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }, r.prototype.applyToEvent = function(t, e) {
    if (this._extra && Object.keys(this._extra).length && (t.extra = o(o({}, this._extra), t.extra)), this._tags && Object.keys(this._tags).length && (t.tags = o(o({}, this._tags), t.tags)), this._user && Object.keys(this._user).length && (t.user = o(o({}, this._user), t.user)), this._contexts && Object.keys(this._contexts).length && (t.contexts = o(o({}, this._contexts), t.contexts)), this._level && (t.level = this._level), this._transactionName && (t.transaction = this._transactionName), this._span) {
      t.contexts = o({ trace: this._span.getTraceContext() }, t.contexts);
      var n = this._span.transaction && this._span.transaction.name;
      n && (t.tags = o({ transaction: n }, t.tags));
    }
    return this._applyFingerprint(t), t.breadcrumbs = p(t.breadcrumbs || [], this._breadcrumbs), t.breadcrumbs = t.breadcrumbs.length > 0 ? t.breadcrumbs : void 0, t.sdkProcessingMetadata = this._sdkProcessingMetadata, this._notifyEventProcessors(p(ut(), this._eventProcessors), t, e);
  }, r.prototype.setSDKProcessingMetadata = function(t) {
    return this._sdkProcessingMetadata = o(o({}, this._sdkProcessingMetadata), t), this;
  }, r.prototype._notifyEventProcessors = function(t, e, n, i) {
    var s = this;
    return i === void 0 && (i = 0), new st(function(a, u) {
      var f = t[i];
      if (e === null || typeof f != "function")
        a(e);
      else {
        var c = f(o({}, e), n);
        q(c) ? c.then(function(h) {
          return s._notifyEventProcessors(t, h, n, i + 1).then(a);
        }).then(null, u) : s._notifyEventProcessors(t, c, n, i + 1).then(a).then(null, u);
      }
    });
  }, r.prototype._notifyScopeListeners = function() {
    var t = this;
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach(function(e) {
      e(t);
    }), this._notifyingListeners = !1);
  }, r.prototype._applyFingerprint = function(t) {
    t.fingerprint = t.fingerprint ? Array.isArray(t.fingerprint) ? t.fingerprint : [t.fingerprint] : [], this._fingerprint && (t.fingerprint = t.fingerprint.concat(this._fingerprint)), t.fingerprint && !t.fingerprint.length && delete t.fingerprint;
  }, r;
}();
function ut() {
  return P("globalEventProcessors", function() {
    return [];
  });
}
var ct = function() {
  function r(t) {
    this.errors = 0, this.sid = S(), this.duration = 0, this.status = "ok", this.init = !0, this.ignoreDuration = !1;
    var e = U();
    this.timestamp = e, this.started = e, t && this.update(t);
  }
  return r.prototype.update = function(t) {
    if (t === void 0 && (t = {}), t.user && (!this.ipAddress && t.user.ip_address && (this.ipAddress = t.user.ip_address), !this.did && !t.did && (this.did = t.user.id || t.user.email || t.user.username)), this.timestamp = t.timestamp || U(), t.ignoreDuration && (this.ignoreDuration = t.ignoreDuration), t.sid && (this.sid = t.sid.length === 32 ? t.sid : S()), t.init !== void 0 && (this.init = t.init), !this.did && t.did && (this.did = "" + t.did), typeof t.started == "number" && (this.started = t.started), this.ignoreDuration)
      this.duration = void 0;
    else if (typeof t.duration == "number")
      this.duration = t.duration;
    else {
      var e = this.timestamp - this.started;
      this.duration = e >= 0 ? e : 0;
    }
    t.release && (this.release = t.release), t.environment && (this.environment = t.environment), !this.ipAddress && t.ipAddress && (this.ipAddress = t.ipAddress), !this.userAgent && t.userAgent && (this.userAgent = t.userAgent), typeof t.errors == "number" && (this.errors = t.errors), t.status && (this.status = t.status);
  }, r.prototype.close = function(t) {
    t ? this.update({ status: t }) : this.status === "ok" ? this.update({ status: "exited" }) : this.update();
  }, r.prototype.toJSON = function() {
    return w({
      sid: "" + this.sid,
      init: this.init,
      started: new Date(this.started * 1e3).toISOString(),
      timestamp: new Date(this.timestamp * 1e3).toISOString(),
      status: this.status,
      errors: this.errors,
      did: typeof this.did == "number" || typeof this.did == "string" ? "" + this.did : void 0,
      duration: this.duration,
      attrs: {
        release: this.release,
        environment: this.environment,
        ip_address: this.ipAddress,
        user_agent: this.userAgent
      }
    });
  }, r;
}(), j = typeof __SENTRY_DEBUG__ > "u" ? !0 : __SENTRY_DEBUG__, R = 4, ft = 100, A = function() {
  function r(t, e, n) {
    e === void 0 && (e = new T()), n === void 0 && (n = R), this._version = n, this._stack = [{}], this.getStackTop().scope = e, t && this.bindClient(t);
  }
  return r.prototype.isOlderThan = function(t) {
    return this._version < t;
  }, r.prototype.bindClient = function(t) {
    var e = this.getStackTop();
    e.client = t, t && t.setupIntegrations && t.setupIntegrations();
  }, r.prototype.pushScope = function() {
    var t = T.clone(this.getScope());
    return this.getStack().push({
      client: this.getClient(),
      scope: t
    }), t;
  }, r.prototype.popScope = function() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }, r.prototype.withScope = function(t) {
    var e = this.pushScope();
    try {
      t(e);
    } finally {
      this.popScope();
    }
  }, r.prototype.getClient = function() {
    return this.getStackTop().client;
  }, r.prototype.getScope = function() {
    return this.getStackTop().scope;
  }, r.prototype.getStack = function() {
    return this._stack;
  }, r.prototype.getStackTop = function() {
    return this._stack[this._stack.length - 1];
  }, r.prototype.captureException = function(t, e) {
    var n = this._lastEventId = e && e.event_id ? e.event_id : S(), i = e;
    if (!e) {
      var s = void 0;
      try {
        throw new Error("Sentry syntheticException");
      } catch (a) {
        s = a;
      }
      i = {
        originalException: t,
        syntheticException: s
      };
    }
    return this._invokeClient("captureException", t, o(o({}, i), { event_id: n })), n;
  }, r.prototype.captureMessage = function(t, e, n) {
    var i = this._lastEventId = n && n.event_id ? n.event_id : S(), s = n;
    if (!n) {
      var a = void 0;
      try {
        throw new Error(t);
      } catch (u) {
        a = u;
      }
      s = {
        originalException: t,
        syntheticException: a
      };
    }
    return this._invokeClient("captureMessage", t, e, o(o({}, s), { event_id: i })), i;
  }, r.prototype.captureEvent = function(t, e) {
    var n = e && e.event_id ? e.event_id : S();
    return t.type !== "transaction" && (this._lastEventId = n), this._invokeClient("captureEvent", t, o(o({}, e), { event_id: n })), n;
  }, r.prototype.lastEventId = function() {
    return this._lastEventId;
  }, r.prototype.addBreadcrumb = function(t, e) {
    var n = this.getStackTop(), i = n.scope, s = n.client;
    if (!(!i || !s)) {
      var a = s.getOptions && s.getOptions() || {}, u = a.beforeBreadcrumb, f = u === void 0 ? null : u, c = a.maxBreadcrumbs, h = c === void 0 ? ft : c;
      if (!(h <= 0)) {
        var g = V(), L = o({ timestamp: g }, t), I = f ? K(function() {
          return f(L, e);
        }) : L;
        I !== null && i.addBreadcrumb(I, h);
      }
    }
  }, r.prototype.setUser = function(t) {
    var e = this.getScope();
    e && e.setUser(t);
  }, r.prototype.setTags = function(t) {
    var e = this.getScope();
    e && e.setTags(t);
  }, r.prototype.setExtras = function(t) {
    var e = this.getScope();
    e && e.setExtras(t);
  }, r.prototype.setTag = function(t, e) {
    var n = this.getScope();
    n && n.setTag(t, e);
  }, r.prototype.setExtra = function(t, e) {
    var n = this.getScope();
    n && n.setExtra(t, e);
  }, r.prototype.setContext = function(t, e) {
    var n = this.getScope();
    n && n.setContext(t, e);
  }, r.prototype.configureScope = function(t) {
    var e = this.getStackTop(), n = e.scope, i = e.client;
    n && i && t(n);
  }, r.prototype.run = function(t) {
    var e = C(this);
    try {
      t(this);
    } finally {
      C(e);
    }
  }, r.prototype.getIntegration = function(t) {
    var e = this.getClient();
    if (!e)
      return null;
    try {
      return e.getIntegration(t);
    } catch {
      return j && m.warn("Cannot retrieve integration " + t.id + " from the current Hub"), null;
    }
  }, r.prototype.startSpan = function(t) {
    return this._callExtensionMethod("startSpan", t);
  }, r.prototype.startTransaction = function(t, e) {
    return this._callExtensionMethod("startTransaction", t, e);
  }, r.prototype.traceHeaders = function() {
    return this._callExtensionMethod("traceHeaders");
  }, r.prototype.captureSession = function(t) {
    if (t === void 0 && (t = !1), t)
      return this.endSession();
    this._sendSessionUpdate();
  }, r.prototype.endSession = function() {
    var t = this.getStackTop(), e = t && t.scope, n = e && e.getSession();
    n && n.close(), this._sendSessionUpdate(), e && e.setSession();
  }, r.prototype.startSession = function(t) {
    var e = this.getStackTop(), n = e.scope, i = e.client, s = i && i.getOptions() || {}, a = s.release, u = s.environment, f = l(), c = (f.navigator || {}).userAgent, h = new ct(o(o(o({
      release: a,
      environment: u
    }, n && { user: n.getUser() }), c && { userAgent: c }), t));
    if (n) {
      var g = n.getSession && n.getSession();
      g && g.status === "ok" && g.update({ status: "exited" }), this.endSession(), n.setSession(h);
    }
    return h;
  }, r.prototype._sendSessionUpdate = function() {
    var t = this.getStackTop(), e = t.scope, n = t.client;
    if (!!e) {
      var i = e.getSession && e.getSession();
      i && n && n.captureSession && n.captureSession(i);
    }
  }, r.prototype._invokeClient = function(t) {
    for (var e, n = [], i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
    var s = this.getStackTop(), a = s.scope, u = s.client;
    u && u[t] && (e = u)[t].apply(e, p(n, [a]));
  }, r.prototype._callExtensionMethod = function(t) {
    for (var e = [], n = 1; n < arguments.length; n++)
      e[n - 1] = arguments[n];
    var i = b(), s = i.__SENTRY__;
    if (s && s.extensions && typeof s.extensions[t] == "function")
      return s.extensions[t].apply(this, e);
    j && m.warn("Extension method " + t + " couldn't be found, doing nothing.");
  }, r;
}();
function b() {
  var r = l();
  return r.__SENTRY__ = r.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, r;
}
function C(r) {
  var t = b(), e = _(t);
  return N(t, r), e;
}
function ht() {
  var r = b();
  return (!W(r) || _(r).isOlderThan(R)) && N(r, new A()), O() ? pt(r) : _(r);
}
function pt(r) {
  try {
    var t = b().__SENTRY__, e = t && t.extensions && t.extensions.domain && t.extensions.domain.active;
    if (!e)
      return _(r);
    if (!W(e) || _(e).isOlderThan(R)) {
      var n = _(r).getStackTop();
      N(e, new A(n.client, T.clone(n.scope)));
    }
    return _(e);
  } catch {
    return _(r);
  }
}
function W(r) {
  return !!(r && r.__SENTRY__ && r.__SENTRY__.hub);
}
function _(r) {
  return P("hub", function() {
    return new A();
  }, r);
}
function N(r, t) {
  if (!r)
    return !1;
  var e = r.__SENTRY__ = r.__SENTRY__ || {};
  return e.hub = t, !0;
}
function $(r) {
  for (var t = [], e = 1; e < arguments.length; e++)
    t[e - 1] = arguments[e];
  var n = ht();
  if (n && n[r])
    return n[r].apply(n, p(t));
  throw new Error("No hub defined or " + r + " was not found on the hub, please open a bug report.");
}
function y(r, t) {
  var e = new Error("Sentry syntheticException");
  return $("captureException", r, {
    captureContext: t,
    originalException: r,
    syntheticException: e
  });
}
function v(r) {
  $("withScope", r);
}
var d;
(function(r) {
  r.CLICK = "click", r.PAGEVIEW = "pageview", r.DEPTH = "depth", r.ERROR = "error", r.API = "api", r.EXPERIMENT = "experiment", r.ENTRY = "entry", r.SINGLE_PAGE_FLOW = "single-page-flow";
})(d || (d = {}));
class St {
  constructor(t, e = []) {
    this.appName = t, this.externalSDKs = e;
  }
  identify(t, e) {
    this.externalSDKs.forEach((n) => {
      var i;
      try {
        (i = n()) == null || i.identify(t, e);
      } catch (s) {
        v((a) => {
          a.setExtra("analytics-client", "Error identifying user"), y(s);
        });
      }
    });
  }
  track(t, e, n = {}) {
    this.externalSDKs.forEach((i) => {
      var s;
      try {
        (s = i()) == null || s.track(`[${e}] ${t}`, {
          event_type: e,
          app: this.appName,
          ...n
        });
      } catch (a) {
        v((u) => {
          u.setExtra("analytics-client", "Error tracking event"), y(a);
        });
      }
    });
  }
  trackClick(t, e = {}) {
    this.track(t, d.CLICK, e);
  }
  trackPageView(t) {
    this.externalSDKs.forEach((e) => {
      var n;
      try {
        (n = e()) == null || n.track("pageview", {
          ...t,
          event_type: d.PAGEVIEW,
          app: this.appName
        });
      } catch (i) {
        v((s) => {
          s.setExtra("analytics-client", "Error tracking page view event"), y(i);
        });
      }
    });
  }
  trackSinglePageFlow(t, e) {
    this.externalSDKs.forEach((n) => {
      var i;
      try {
        (i = n()) == null || i.track("pageview", {
          ...e,
          event_type: d.SINGLE_PAGE_FLOW,
          app: this.appName,
          flow_step: t
        });
      } catch (s) {
        v((a) => {
          a.setExtra("analytics-client", "Error tracking single page flow event"), y(s);
        });
      }
    });
  }
  reset() {
    this.externalSDKs.forEach((t) => {
      var e, n;
      try {
        (n = (e = t()) == null ? void 0 : e.reset) == null || n.call(e);
      } catch (i) {
        v((s) => {
          s.setExtra("analytics-client", "Error reseting session"), y(i);
        });
      }
    });
  }
}
function _t(r, t) {
  return function() {
    const n = r(), i = H(t);
    function s(f, c, h = {}) {
      n.track(f, c, {
        ...i,
        ...h
      });
    }
    function a(f, c = {}) {
      n.trackClick(f, {
        ...i,
        ...c
      });
    }
    function u(f, c = {}) {
      n.trackSinglePageFlow(f, {
        ...i,
        ...c
      });
    }
    return {
      EventType: d,
      track: s,
      trackClick: a,
      trackSinglePageFlow: u
    };
  };
}
function lt(r) {
  return function() {
    const e = H(r);
    if (!e)
      throw new Error("Couldn't find an AnalyticsClient. Are you sure you configured an AnalyticsProvider with one?");
    return e;
  };
}
function dt(r) {
  return Y(r);
}
function gt() {
  const r = Y(null);
  return {
    AnalyticsClientContext: r,
    AnalyticsProvider: ({
      analyticsClient: e,
      children: n
    }) => X(r.Provider, {
      value: e,
      children: n
    })
  };
}
function mt() {
  const r = dt({}), { AnalyticsProvider: t, AnalyticsClientContext: e } = gt(), n = lt(e), i = _t(n, r);
  return {
    AnalyticsPageContext: r,
    AnalyticsProvider: t,
    AnalyticsClientContext: e,
    useAnalyticsClient: n,
    useAnalytics: i
  };
}
export {
  St as AnalyticsClient,
  d as AnalyticsEventType,
  dt as createAnalyticsPageContext,
  gt as createAnalyticsProvider,
  mt as createAnalyticsReactModule,
  _t as createUseAnalytics,
  lt as createUseAnalyticsClient
};
//# sourceMappingURL=analytics-core.es.js.map
